import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import {
  ACTION,
  DEFAULT_REMESH_SETTINGS,
  PROVIDER,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Tripo3D mesh-simplification-default
 * run. Produces remeshSettings (faceLevel + polygonType from the run, default
 * targetPolycount) and opens the viewer sidebar on the REMESH tab.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTripo3dMeshSimplificationDefaultData = (openedModel) => {
  const {
    id: sessionId,
    modelFormatOutput: rawModelFormatOutput,
    generatorSessionId,
    outputAssets,
  } = openedModel
  const {
    faceLevel,
    polygonType,
    topology,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const enhancedProvider = PROVIDER.TRIPO3D
  const enhancedAction = ACTION.MESH_SIMPLIFICATION
  const isSmartLowPoly = true
  const targetPolycount = DEFAULT_REMESH_SETTINGS.targetPolycount

  const schema = { enhancedAction, enhancedProvider }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD }
  const remeshSettings = {
    isSmartLowPoly,
    faceLevel,
    targetPolycount,
    // Persisted Tripo3D rows store `topology`; the optimistic builder path
    // still sends camelCase `polygonType`.
    polygonType: polygonType || topology,
  }
  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.REMESH,
  }

  return {
    openedModel,
    schema,
    remeshSettings,
    ui,
    generation,
    viewer,
  }
}
